import { render, staticRenderFns } from "./acl.vue?vue&type=template&id=e52684ea"
import script from "./acl.vue?vue&type=script&lang=ts"
export * from "./acl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports